import React from "react";
import styles from "./SmartResume.module.css";
import visuals from "../../../Images/ResumeSteps.svg"; // your single SVG

const SmartResume = () => {
  return (
    <section className={styles.smartResume}>
      <div className={styles.container}>
        {/* Left Side: Text */}
        <div className={styles.textContent}>
          <h2>
            How AI Makes Resume <br /> Screening Smarter
          </h2>
          <p>
            With ToxBox AI, every resume is evaluated consistently, helping
            recruiters make data-driven hiring decisions without bias or delays.
          </p>

          <ul className={styles.steps}>
            <li>
              <strong>1. Upload resumes in bulk (PDF, DOCX, TXT).</strong>
            </li>
            <li>
              2. AI parses resumes to extract skills, experience, education, and
              certifications.
            </li>
            <li>
              3. Candidates are scored and ranked based on your job
              requirements.
            </li>
            <li>
              4. Apply filters for role-specific needs, such as skills,
              experience, or location.
            </li>
            <li>
              5. Automatically shortlist the best candidates for interviews.
            </li>
          </ul>
        </div>

        {/* Right Side: SVG Illustration */}
        <div className={styles.visuals}>
          <img src={visuals} alt="Resume screening process illustration" />
        </div>
      </div>
    </section>
  );
};

export default SmartResume;
